import {Box, Stack, Typography} from '@mui/material'
import React from 'react'

import {ItemsTreeResponse} from '../../../common/types'
import {dataTestId} from '../../../common/utils'
import {CardBox} from '../containers/'
import {Loader} from '../progress'

import {VerticalNavigationHeader} from './VerticalNavigationHeader'
import {VerticalNavigationItem} from './VerticalNavigationItem'

export const VerticalNavigationTree = ({
  selectedDate,
  width,
  selectedResourceId,
  setSelectedResource,
  isLoading,
  isFetching,
  tree,
  oldStructure,
  noDataLabel
}: {
  selectedDate: string
  width?: string
  selectedResourceId?: string
  setSelectedResource: (selected: string) => void
  tree: ItemsTreeResponse | undefined
  isLoading: boolean
  isFetching: boolean
  oldStructure?: boolean
  noDataLabel?: string
}) => {
  return (
    <CardBox
      width={width ?? '100%'}
      {...dataTestId('vertical-navigation-tree-container')}
      overflow="auto"
      style={{padding: 'unset'}}
    >
      {isLoading || isFetching ? (
        <Loader />
      ) : !tree?.items || tree.items.length === 0 ? (
        <Box width="100%" display="flex" flexDirection="row" justifyContent="center">
          <Typography>{noDataLabel}</Typography>
        </Box>
      ) : (
        <Stack
          direction="column"
          justifyContent="space-between"
          {...dataTestId('vertical-navigation-tree')}
          alignItems={'left'}
        >
          <VerticalNavigationHeader selectedDate={selectedDate} />
          {tree?.items.map((area) => (
            <VerticalNavigationItem
              oldStructure={oldStructure}
              key={area.id}
              node={area}
              selectedItemId={selectedResourceId}
              level={0}
              onClick={(item) => setSelectedResource(item)}
            />
          ))}
        </Stack>
      )}
    </CardBox>
  )
}
